// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selected[data-v-60c292b1] .svg-icon g,.svg-icon ellipse[data-v-60c292b1],.svg-icon path[data-v-60c292b1],.svg-icon polygon[data-v-60c292b1],.svg-icon rect[data-v-60c292b1]{fill:#1976d2}.svg-icon ellipse[data-v-60c292b1],.svg-icon path[data-v-60c292b1],.svg-icon polygon[data-v-60c292b1],.svg-icon rect[data-v-60c292b1],.unselected[data-v-60c292b1] .svg-icon g{fill:#3c3c3c}.global-search--fixed[data-v-60c292b1]{position:fixed}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
